<div class="common-lateral-panel common-lateral-panel--icam-state">
  <div class="common-section-title__lp-container">
    <div class="common-section-title__lp-title-icon">
      <i class="lf-icon-process common-icon__lg"></i>
      <span class="common-section-title__lp-label-text"
        [afTranslate]="'box-query-state.query-state'">_Estado actual de la consulta</span>
    </div>
  </div>
    <div class="common-lateral-panel__process-container">
      <div class="sidepanel-styles__container-styles">
        @for (state of boxQueryState.states; track $index) {
          <div class="sidepanel-styles__element-container"
            [ngClass]="{'sidepanel-styles__element-container--active': state.active}">
            <hr [ngClass]="state.active?'sidepanel-styles__active-section-line':'sidepanel-styles__middlend-section-line'">
            @if (state.active) {
              <div class="common-tag__neutral-light">
                <span class="common-tag__neutral-label-text">{{boxQueryState.actualState.name}}</span>
              </div>
            }
          </div>
        }
      </div>
    </div>
</div>



<!-- <div class="attachments-template attachments-template--custom">
    <div class="attachments-template__custom-header">
        <i class="lf-icon-process attachments-template__custom-add-icon"></i>
        <p class="attachments-template__custom-header-title"
            [afTranslate]="'box-query-state.query-state'">_Estado actual de la consulta</p>
    </div>
    <div>
        <div class="box-query-state__progress-bar-custom">
            <div class="box-query-state__progress-selected-bar-custom"></div>
        </div>
        <div class="box-query-state__block-status">
            <i class="lf-icon-radio-button-active box-query-state__icon-status-progress"></i>
            <span>{{boxQueryState.actualState.name}}</span>
        </div>
    </div>
</div> -->
